import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

export default function ForgotPasswordBusiness() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await fetch(`${API_URL}/api/business/forgot-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
    const data = await res.json();
    setMessage(data.message);
  };

  return (
    <div className="container mt-5" style={{ maxWidth: '400px' }}>
      <h3>İşletme Şifremi Unuttum</h3>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          className="form-control mt-3"
          placeholder="E-posta adresiniz"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" className="btn btn-success w-100 mt-3">
          Şifre Sıfırlama Linki Gönder
        </button>
      </form>
      {message && <p className="text-center mt-3">{message}</p>}
    </div>
  );
}
